import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { RequireAuth } from './components/RequireAuth';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { UndoProvider } from './context/UndoContext';
import { TeamProvider } from './context/TeamContext';
import { InboxView } from './views/InboxView';
import { LoginView } from './views/LoginView';
import { PrivateView } from './views/PrivateView';
import { ScopeView } from './views/ScopeView';
import { TrashView } from './views/TrashView';
import { NotFoundView } from './views/NotFoundView';

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginView />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <TeamProvider>
                  <UndoProvider>
                    <AppShell>
                      <Routes>
                        <Route path="/" element={<InboxView />} />
                        <Route path="/scope/:scopeSlug" element={<ScopeView />} />
                        <Route path="/private" element={<PrivateView />} />
                        <Route path="/trash" element={<TrashView />} />
                        <Route path="*" element={<NotFoundView />} />
                      </Routes>
                    </AppShell>
                  </UndoProvider>
                </TeamProvider>
              </RequireAuth>
            }
          />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
